"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CardHeader2 = _interopRequireDefault(require("@mui/material/CardHeader"));
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _icons = require("../icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function WayPointCard({
  isArrival,
  bikeStationsMap,
  route: {
    wayPoints,
    sections
  },
  sectionIndex
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const section = sections[sectionIndex];
  const departure = wayPoints[sectionIndex];
  const arrival = wayPoints[wayPoints.length - 1];
  const prevSection = sections[sectionIndex - 1];
  const bikeStations = 'bikeStations' in section && section.bikeStations || undefined;
  const departureBikeStation = bikeStations ? bikeStations.from : prevSection && 'bikeStations' in prevSection && prevSection.bikeStations?.to || undefined;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: isArrival ? 'arrival' : '',
    elevation: 0
  }, /*#__PURE__*/_react.default.createElement(StyledHeader, {
    avatar: isArrival ? /*#__PURE__*/_react.default.createElement(_icons.ArrivalIcon, null) : sectionIndex === 0 ? /*#__PURE__*/_react.default.createElement(_icons.DepartureIcon, null) : /*#__PURE__*/_react.default.createElement(_icons.StepIcon, null),
    className: isArrival ? 'arrival' : sectionIndex === 0 ? 'departure' : '',
    subheader: isArrival ? arrival.addressDetail?.secondaryText : departureBikeStation ? departure.address : departure.addressDetail?.secondaryText,
    title: isArrival ? arrival.addressDetail?.primaryText : departureBikeStation ? t('commons.routing.roadmap.bike_station_name', {
      name: bikeStationsMap[departureBikeStation.bikeStationId]?.name || ''
    }) : departure.addressDetail?.primaryText
  }));
}
const Wrapper = (0, _styledComponents.styled)(_Card2.default)`
  && {
    background-color: transparent;

    &.arrival {
      margin-top: 24px;
    }
  }
`;
const StyledHeader = (0, _styledComponents.styled)(_CardHeader2.default)`
  &.departure {
    align-items: flex-start;
  }

  &.arrival {
    align-items: flex-end;
  }

  .MuiCardHeader-avatar {
    height: 24px;
    z-index: 2;
  }

  .MuiCardHeader-title {
    font-size: 1.1em;
  }
`;
var _default = exports.default = WayPointCard;